import _flexbox from "../dict/flexbox.js";
import _convertToPlainTextCustom from "../functions/quill/convertToPlainTextCustom.js";
import _alignments from "../dict/alignments.js";
import _convertStylestoStyleMap from "../functions/special/convertStylestoStyleMap.js";
import _convertRegionsToPositionMap from "../functions/special/convertRegionsToPositionMap.js";
import _JsonFind from "json-find";
import _eol from "eol";
import { XMLParser as _XMLParser } from "fast-xml-parser";
import _formatXml from "xml-formatter";
import _ttmlFunc from "../functions/profiles/ttmlGeneral.js";
import _convertToPlainText from "../functions/quill/convertToPlainText.js";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _tcLib from "../lib/timecode.js";
import _Event from "../classes/event.js";
const Event = _Event;
const tcLib = _tcLib;
const getFormatOptions = _getFormatOptions;
const removeInvalidEvents = _removeInvalidEvents;
const convertToHtml = _convertToHtml;
const convertToPlainText = _convertToPlainText;
const ttmlFunc = _ttmlFunc;
const formatXml = _formatXml; //Encode
const XMLParser = _XMLParser; //Decode
const eol = _eol;
const JsonFind = _JsonFind;
const convertRegionsToPositionMap = _convertRegionsToPositionMap;
const convertStylestoStyleMap = _convertStylestoStyleMap;
const alignments = _alignments;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const flexbox = _flexbox;
function getClosestFlexboxPosition(position, dimension) {
  if (typeof position === "string") {
    return position;
  }
  let percentage = position / dimension * 100;
  if (percentage <= 33) {
    return "start";
  } else if (percentage >= 67) {
    return "end";
  }
  return "center";
}
function resolveRegionId(event, window) {
  let xRegion = flexbox.flexMap.horizontal[event.xPos] || flexbox.flexMap.horizontal[getClosestFlexboxPosition(event.xPos, window.width)];
  let yRegion = flexbox.flexMap.vertical[event.yPos] || flexbox.flexMap.vertical[getClosestFlexboxPosition(event.yPos, window.height)];
  if (!xRegion) {
    xRegion = "center";
  }
  if (!yRegion) {
    yRegion = "bottom";
  }
  return yRegion + xRegion.charAt(0).toUpperCase() + xRegion.slice(1);
}
export default {
  decode: function (input, options) {
    let events = [],
      ccEvent;
    const xmlToJson = new XMLParser({
      stopNodes: ["*.p"],
      numberParseOptions: {
        skipLike: /[0-9]+/
      },
      ignoreAttributes: false
    });
    let jsonInput = xmlToJson.parse(input);
    let regions = JsonFind(jsonInput).findValues("region") || {
      region: []
    };
    let styles = JsonFind(jsonInput).findValues("style") || {
      style: []
    };
    let tt = JsonFind(jsonInput).findValues("tt") || {
      tt: {}
    };
    let useClockTime = tt.tt["@_ttp:timeBase"] && (tt.tt["@_ttp:timeBase"] === "clock" || tt.tt["@_ttp:timeBase"] === "media") ? true : false;
    if (!Array.isArray(regions.region)) {
      regions.region = [regions.region];
    }
    if (!Array.isArray(styles.style)) {
      styles.style = [styles.style];
    }
    let styleMap = convertStylestoStyleMap(styles.style);

    //Check if p property is an array or object
    if (jsonInput.tt.body.div.p.length === undefined) {
      jsonInput.tt.body.div.p = [jsonInput.tt.body.div.p];
    }
    jsonInput.tt.body.div.p.forEach(paragraph => {
      if (!paragraph["#text"]) {
        return;
      }
      ccEvent = new Event();
      ccEvent.start = tcLib.parseTcToSec(paragraph["@_begin"], options.frameRate, options.dropFrame, useClockTime);
      ccEvent.end = tcLib.parseTcToSec(paragraph["@_end"], options.frameRate, options.dropFrame, useClockTime);

      // console.log(paragraph["@_begin"], paragraph["@_end"]);
      // console.log(ccEvent.start, ccEvent.end);

      ccEvent.text = convertToHtml(ttmlFunc.multiLine.formatText(paragraph["#text"]).replace(/<br \/>|<br\/>|<br>/gim, "\n"));
      let positionMap = convertRegionsToPositionMap(regions.region, paragraph["@_tts:textAlign"]);
      if (paragraph["@_region"]) {
        ccEvent = {
          ...ccEvent,
          ...positionMap[paragraph["@_region"]]
        };
      } else {
        ccEvent.xPos = "center";
        ccEvent.yPos = "end";
      }
      if (paragraph["@_tts:textAlign"] && alignments.includes(paragraph["@_tts:textAlign"])) {
        ccEvent.alignment = paragraph["@_tts:textAlign"];
      } else if (paragraph["textAlign"] && alignments.includes(paragraph["textAlign"])) {
        ccEvent.alignment = paragraph["textAlign"];
      } else if (paragraph["@_style"] && styleMap[paragraph["@_style"]] && styleMap[paragraph["@_style"]]["@_tts:textAlign"] && alignments.includes(styleMap[paragraph["@_style"]]["@_tts:textAlign"])) {
        ccEvent.alignment = styleMap[paragraph["@_style"]]["@_tts:textAlign"];
      }
      events.push(ccEvent);
    });
    return events;
  },
  encode: function (eventGroup, options) {
    let encodingOptions = getFormatOptions(options.formatOptions);
    //console.log(encodingOptions);
    let languageCode = encodingOptions["Language Code"] || "en-US";
    let fontFamily = encodingOptions["Font Family"] || "SansSerif";
    let fontSize = encodingOptions["Font Size"] || 10;
    let fontWeight = encodingOptions["Font Weight"] || "normal";
    let fontStyle = encodingOptions["Font Style"] || "normal";
    let encodeFormatting = encodingOptions["Encode Formatting"] || false;
    let encodeColor = encodingOptions["Encode Color"] && encodingOptions["Encode Color"] !== false;
    let backgroundColor = encodingOptions["Background Color"] || "transparent";
    let textColor = encodingOptions["Text Color"] || "white";
    let formatXmlOpt = encodingOptions["Format XML"] || false;
    let frameRateMultiplier = ttmlFunc.frameRateMultiplierMap[options.frameRate];
    let output = eol.after('<?xml version="1.0" encoding="UTF-8"?>');
    output += eol.after(`    <tt xml:lang="${languageCode}" xmlns="http://www.w3.org/ns/ttml" xmlns:tts="http://www.w3.org/ns/ttml#styling" xmlns:ttm="http://www.w3.org/ns/ttml#metadata" xmlns:ttp="http://www.w3.org/ns/ttml#parameter" ttp:frameRate="${ttmlFunc.frameRateMap[options.frameRate]}" ttp:frameRateMultiplier="${frameRateMultiplier}" ttp:timeBase="media" ttp:dropMode="${options.dropFrame ? "dropNTSC" : 'nonDrop'}">`);
    output += eol.after(`        <head>
			<layout>
				<region xml:id="topLeft"  tts:showBackground="whenActive" tts:extent="80% 50%" tts:origin="10% 10%" tts:displayAlign="before"/>
				<region xml:id="centerLeft" tts:showBackground="whenActive" tts:extent="80% 50%" tts:origin="10% 5%" tts:displayAlign="after"/>
				<region xml:id="bottomLeft" tts:showBackground="whenActive" tts:extent="80% 50%" tts:origin="10% 40%" tts:displayAlign="after"/>
				<region xml:id="topCenter" tts:showBackground="whenActive" tts:extent="80% 50%" tts:origin="10% 10%" tts:displayAlign="before"/>
				<region xml:id="centerCenter" tts:showBackground="whenActive" tts:extent="80% 50%" tts:origin="10% 5%" tts:displayAlign="after"/>
				<region xml:id="bottomCenter" tts:showBackground="whenActive" tts:extent="80% 50%" tts:origin="10% 40%" tts:displayAlign="after"/>
				<region xml:id="topRight" tts:showBackground="whenActive" tts:extent="80% 50%" tts:origin="10% 10%" tts:displayAlign="before"/>
				<region xml:id="centerRight" tts:showBackground="whenActive" tts:extent="80% 50%" tts:origin="10% 5%" tts:displayAlign="after"/>
				<region xml:id="bottomRight" tts:showBackground="whenActive" tts:extent="80% 50%" tts:origin="10% 40%" tts:displayAlign="after"/>
			</layout>
			<styling>
				<style xml:id="defaultCaption" tts:fontSize="${fontSize}" tts:fontFamily="${fontFamily}" tts:fontWeight="${fontWeight}" tts:fontStyle="${fontStyle}" tts:textDecoration="none" tts:color="${textColor}" tts:backgroundColor="${backgroundColor}" />
			</styling>
			<metadata>
				<ttm:desc>Encoded by Closed Caption Converter v3.5</ttm:desc>
			</metadata>
		</head>
		<body>
			<div style="defaultCaption" xml:lang="${languageCode}">`);
    eventGroup.events.forEach(event => {
      let regionId = resolveRegionId(event, options.window);
      let alignment = event.alignment || "center";
      let plainTextCustom = convertToPlainTextCustom(event.text, "\n", false, "strong", "em", "u", encodeColor);
      let text;
      if (encodeFormatting || encodeColor) {
        text = ttmlFunc.multiLine.convertToTtml(plainTextCustom);
      } else {
        text = convertToPlainText(event.text).replace(/\n/gim, "<br />");
      }
      output += eol.after(`                <p begin="${event.startMsIncode.replace(",", ".")}" end="${event.endMsIncode.replace(",", ".")}" region="${regionId}" tts:textAlign="${alignment}" xml:space="default">${text}</p>`);
    });
    output += `            </div>
		</body>
	</tt>`;
    if (formatXmlOpt) {
      return formatXml(output);
    } else {
      return output;
    }
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      return input;
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};